import { useState } from 'react';
import { toast } from 'react-toastify';
import { X } from 'lucide-react';
import { Card, DatePickerInput, MediaUpload } from '@components/ui';
import { expenseCategories, paymentMethods } from '@mocks/harcamalar';

export default function HarcamaModal({ isOpen, onClose }) {
    const [selectedDate, setSelectedDate] = useState(new Date());

    if (!isOpen) return null;

    const handleSave = () => {
        toast.success('Harcama başarıyla eklendi');
        onClose();
    };

    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={onClose}>
            <Card padding="lg" className="w-full max-w-md" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-6">
                    <h3 className="text-lg font-semibold text-text-primary">Yeni Harcama</h3>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-bg-hover rounded-lg transition-colors text-text-tertiary"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="space-y-4">
                    <DatePickerInput
                        value={selectedDate}
                        onChange={setSelectedDate}
                        label="Tarih"
                        placeholder="Tarih seçin"
                    />

                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Kategori</label>
                        <select className="w-full px-3 py-2 bg-bg-secondary border border-border-light rounded-lg text-text-primary focus:outline-none focus:ring-2 focus:ring-primary">
                            {expenseCategories.map(cat => (
                                <option key={cat.key} value={cat.key}>{cat.label}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Açıklama</label>
                        <input
                            type="text"
                            placeholder="Harcama açıklaması..."
                            className="w-full px-3 py-2 bg-bg-secondary border border-border-light rounded-lg text-text-primary focus:outline-none focus:ring-2 focus:ring-primary"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Tutar (₺)</label>
                        <input
                            type="number"
                            placeholder="0"
                            className="w-full px-3 py-2 bg-bg-secondary border border-border-light rounded-lg text-text-primary focus:outline-none focus:ring-2 focus:ring-primary"
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Ödeme Şekli</label>
                        <select className="w-full px-3 py-2 bg-bg-secondary border border-border-light rounded-lg text-text-primary focus:outline-none focus:ring-2 focus:ring-primary">
                            {paymentMethods.map(method => (
                                <option key={method.key} value={method.key}>{method.label}</option>
                            ))}
                        </select>
                    </div>

                    <MediaUpload
                        mode="single"
                        accept="all"
                        label="Fiş / Fatura"
                        hint="Görsel veya PDF — kameradan doğrudan çekebilirsiniz"
                        maxSizeMB={10}
                        compact
                        onFilesChange={() => {}}
                    />
                </div>

                <div className="mt-6 flex gap-2">
                    <button
                        onClick={handleSave}
                        className="flex-1 py-2.5 px-4 bg-secondary text-white rounded-lg hover:bg-secondary-dark transition-colors font-medium min-h-[48px]"
                    >
                        Kaydet
                    </button>
                    <button
                        onClick={onClose}
                        className="flex-1 py-2 px-4 bg-bg-tertiary text-text-primary rounded-lg hover:bg-bg-hover transition-colors font-medium"
                    >
                        İptal
                    </button>
                </div>
            </Card>
        </div>
    );
}
